import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DateFnsUtils from '@date-io/date-fns';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Alert from '@material-ui/lab/Alert';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import CircularProgress from 'material-ui/CircularProgress';
import { TimePicker } from "@material-ui/pickers";
import Typography from '@material-ui/core/Typography';
import NewIncidentMap from './NewIncidentMap.js';
import Snackbar from '@material-ui/core/Snackbar';
import Select from '@material-ui/core/Select';
import originFields from '../../defaults/PointOfOriginFields.json';
import theme from '../../muiTheme';
import { incidentOperations } from '../../redux/incident';
import { getOriginValidationInfo } from '../../utils/incidentHelper';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import { getMapExtent } from '../esri/mapHub';
import * as coordinateFormatter from '@arcgis/core/geometry/coordinateFormatter';
import Point from '@arcgis/core/geometry/Point';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import * as webMercatorUtils from '@arcgis/core/geometry/support/webMercatorUtils';
import './NewIncidentDialog.css';
import { history } from '../../index';

const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
};

export class NewIncidentDialog extends Component {
  constructor(props) {
    super(props);

    this.locaIndentifierRef = React.createRef();
    this.incidentNameRef = React.createRef();
    let attributes = {};

    attributes[originFields.name] = null;
    attributes["fireDiscoveryDate"] = new Date();
    attributes["fireDiscoveryTime"] = new Date();
    attributes[originFields.incidentTypeCategory] = "WF";
    attributes[originFields.incidentTypeKind] = "FI";
    attributes[originFields.localIncidentIdentifier] = null;
    attributes[originFields.discoveryAcres] = null;
    attributes[originFields.pooProtectingUnit] = this.props.incident.newIncidentProtectingUnit;
    attributes[originFields.isFSAssisted] = this.props.incident.newIncidentIsFSAssist
    attributes[originFields.isFireCodeRequested] = this.props.incident.newIncidentIsFireCodeRequest

    this.state =
    {
      showUnitIdWarning: false,
      isQueryingUnitId: false,
      unitIdIsValid: false,
      unitIdString: '',
      mapIsLoaded: false,
      latLongIsValid: false,
      attributes: attributes,
      lat: null,
      long: null,
      latValue: "",
      longValue: "",
      canAddIncident: false,
      errorText: "Please define a point of origin.",
      invalidDiscoveryDate: false,
      showAddFailure: false,
      addFailureMessage: "",
      ddFormat: 'dd',
      pooProtectingUnit: this.props.incident.newIncidentProtectingUnit,
      incidentNameValue: '',
      localIncidentIdentifierValue: '',
      stateCode: '',
      fireSize: 0,
      isFireCodeRequest: this.props.incident.newIncidentIsFireCodeRequest,
      isFSAssist: this.props.incident.newIncidentIsFSAssist
    };
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.open && !this.props.open) {
      const copy = Object.assign({}, this.state.attributes);
      copy["fireDiscoveryDate"] = new Date();
      copy["fireDiscoveryTime"] = new Date();
      copy[originFields.localIncidentIdentifier] = null;
      copy[originFields.name] = null;

      this.setState(
        {
          attributes: copy,
          incidentNameValue: '',
          localIncidentIdentifierValue: '',
          lat: null,
          long: null,
          latValue: "",
          longValue: "",
          latLongIsValid: false,
          canAddIncident: false,
          showUnitIdWarning: false,
          isQueryingUnitId: false,
          fireSize: 0
        });
    }

  }

  lookupLocalId = () => {
    window.api.getLastLII(this.state.attributes[originFields.pooProtectingUnit]).then(unitIdResponse => {
      let attributes = this.state.attributes;

      attributes[originFields.localIncidentIdentifier] = unitIdResponse;

      this.setState({
        attributes: attributes,
        localIncidentIdentifierValue: unitIdResponse
      });

    });
  }
  verifyUnitId = () => {
    this.setState({
      isQueryingUnitId: true,
      showUnitIdWarning: false
    });

    window.api.getUnitId(this.state.attributes[originFields.pooProtectingUnit]).then(unitIdResponse => {
      const unitIdIsValid = (unitIdResponse && unitIdResponse.units && unitIdResponse.units.length > 0);
      const unitIdString = (unitIdIsValid) ? unitIdResponse.units[0].NAME : this.state.attributes[originFields.pooProtectingUnit] + " is not a valid unit";

      this.setState({
        isQueryingUnitId: false,
        showUnitIdWarning: true,
        unitIdIsValid: unitIdIsValid,
        unitIdString: unitIdString
      });
    });
  }
  updateLatLong = (lat, long) => {
    this.setState({
      latValue: lat,
      longValue: long
    });
  }

  setLatLongFromUserInput = (userLat, userLong) => {

      coordinateFormatter.load().then(() => {
        var newPoint = coordinateFormatter.fromLatitudeLongitude(userLat + " " + userLong);

        if (newPoint) {
          this.setState({
            lat: newPoint.latitude,
            long: newPoint.longitude,
            latLongIsValid: true
          });
        } else {
          this.setState({
            lat: null,
            long: null,
            latValue: userLat,
            longValue: userLong,
            latLongIsValid: false,
            canAddIncident: false,
            errorText: "Latitude and/or Longitude is invalid."
          });
        }

        this.checkAttributes(this.state.latLongIsValid);
      });
  }

  handleLLFormatChange = (newFormat) => {
      let newPoint = new Point
        ({
          latitude: this.state.lat,
          longitude: this.state.long,
          spatialReference: new SpatialReference(4326)
        });

      // Load dependencies of "coordinateFormatter" module
      coordinateFormatter.load().then(() => {

        var newLocationString = coordinateFormatter.toLatitudeLongitude(newPoint, newFormat, 6);
        let lat = newLocationString.substring(0, newLocationString.indexOf("N") + 1);
        let long = newLocationString.substring(lat.length + 1);

        this.setState({
          ddFormat: newFormat
        });

        this.updateLatLong(lat, long);
      });
  }

  latLongIsValid = (lat, long) => {
    const isValidNumber = n => typeof n === 'number' && !Number.isNaN(n);
    return (
      isValidNumber(lat) &&
      isValidNumber(long) &&
      lat >= -90 && lat <= 90 &&
      long >= -180 && long <= 180
    );
  };

  handleSnackRequestClose = () => {
    this.setState({
      canAddIncident: true,
      showAddFailure: false
    });
  }

  onAddNewIncident = () => {

      this.setState({
        canAddIncident: false
      });

      let geographicPoint = new Point
        ({
          latitude: this.state.lat,
          longitude: this.state.long,
          spatialReference: new SpatialReference(4326)
        });

      let mercatorPoint = webMercatorUtils.geographicToWebMercator(geographicPoint);

      let newIncidentFeature =
      {
        attributes: this.state.attributes,
        geometry: {
          x: this.state.long,
          y: this.state.lat,
          spatialReference: {
            wkid: 4269,
            latestWkid: 4269
          }
        }
      }

      const year = this.state.attributes["fireDiscoveryDate"].getFullYear();
      const month = this.state.attributes["fireDiscoveryDate"].getMonth();
      const date = this.state.attributes["fireDiscoveryDate"].getDate();

      const hour = this.state.attributes["fireDiscoveryTime"].getHours();
      const minute = this.state.attributes["fireDiscoveryTime"].getMinutes();
      const second = this.state.attributes["fireDiscoveryTime"].getSeconds();

      newIncidentFeature.attributes[originFields.discoveryDate] = new Date(year, month, date, hour, minute, second).valueOf();

      //Set Daily Acres to Discovery Acres
      newIncidentFeature.attributes[originFields.incidentSize] = newIncidentFeature.attributes[originFields.discoveryAcres];
      newIncidentFeature.attributes[originFields.pooProtectingUnit] = newIncidentFeature.attributes[originFields.pooProtectingUnit].toUpperCase();

      //Get rid of attributes IRWIN doesn't care about
      if (newIncidentFeature.attributes[originFields.incidentTypeCategory] === "FA") {
        delete newIncidentFeature.attributes[originFields.incidentSize];
        delete newIncidentFeature.attributes[originFields.discoveryAcres];
      }


      getMapExtent().then(
        result => {

          window.api.addIncident(newIncidentFeature, mercatorPoint).then(
            result => {
              if (result !== null && result.FORID) {
                this.setState({
                  lat: null,
                  long: null,
                  latValue: "",
                  longValue: "",
                  errorText: "",
                  latLongIsValid: false
                });

                this.props.onNewIncidentClose();
                history.push("/incidents/" + result.FORID);
              }
              else {
                this.setState({
                  addFailureMessage: "Error: Incident was not added: " + result.description[0].description,
                  showAddFailure: true
                });
              }
            });
        }
      );
  }

  updateCoords = (lat, long) => {

    if (lat === this.state.lat && long === this.state.long) {
      return;
    }
    this.setState({
      lat: lat,
      long: long,
      latLongIsValid: true,
      latValue: lat,
      longValue: long,
      errorText: ""
    });

    window.api.getStateFromOrigin(lat, long).then(
      result => {
        window.api.validateLatLong(lat, long).then(latLongIsValid => {

          if (latLongIsValid) {
            this.setState({
              stateCode: result
            });

            let attributes = this.state.attributes;
            let newValue = (result) ? (result + "UNK") : "";

            //We already have a code for this state, don't set it to UNK
            if (this.state.pooProtectingUnit.startsWith(result)) {
              return;
            }
            attributes[originFields.pooProtectingUnit] = result + "UNK";

            this.setState({
              attributes: attributes,
              pooProtectingUnit: newValue,
              latLongIsValid: latLongIsValid
            });

            this.props.setNewIncidentProtectingUnit(newValue);
            this.checkAttributes(latLongIsValid);
          }
          else {
            this.setState({
              canAddIncident: false,
              latLongIsValid: false
            });
          }
        });
      }
    );
  }

  checkAttributes = (latLongIsValid) => {

    if (!latLongIsValid) {
      this.setState({
        canAddIncident: false,
        errorText: "Lat/Long did not intersect US State and Territory boundaries"
      });

      return;
    }

    let canAdd = true;
    let errorText = "";
    if (this.state.lat === null || this.state.long === null) {
      canAdd = false;
      errorText = "Please provide a valid point of origin.";
    }

    const regex = /\p{Extended_Pictographic}/ug;
    const specialCharRegex = /[`!@$^*+;=[\]{}\\|àé,<>?]/;

    if (this.state.attributes[originFields.incidentTypeCategory] === 'RX') {

      if (this.state.attributes[originFields.name] && ((!this.state.attributes[originFields.name].includes("RX ") && !this.state.attributes[originFields.name].includes(" RX")))) {
        canAdd = false;
        errorText = "Prescribed Fire Incident Name must include RX";
      }
    }

    if (this.state.attributes[originFields.name] && (this.state.attributes[originFields.name].startsWith(" ") || this.state.attributes[originFields.name].endsWith(" "))) {
      canAdd = false;
      errorText = "Incident name cannot have leading or trailing spaces";
    }

    if (this.state.attributes[originFields.name] && (this.state.attributes[originFields.name].startsWith("-"))) {
      canAdd = false;
      errorText = "Incident name cannot start with a hyphen";
    }

    if (this.state.attributes[originFields.name]) {
      if (regex.test(this.state.attributes[originFields.name])) {
        canAdd = false;
        errorText = "Incident name cannot contain emojis";
      }

      if (specialCharRegex.test(this.state.attributes[originFields.name])) {
        canAdd = false;
        errorText = "Incident name cannot contain special characters";
      }
    }


    if (this.state.attributes[originFields.name] && this.state.attributes[originFields.name].includes("  ")) {
      canAdd = false;
      errorText = "Incident name cannot contain multiple consecutive spaces";
    }

    if (this.state.attributes[originFields.name] && (this.state.attributes[originFields.name].startsWith("-") || this.state.attributes[originFields.name].startsWith("+"))) {
      canAdd = false;
      errorText = "Incident name cannot start with '+' or '-'";
    }

    if (this.state.attributes[originFields.name] === null || this.state.attributes[originFields.name] === "" || this.state.attributes[originFields.localIncidentIdentifier] === null || this.state.attributes[originFields.localIncidentIdentifier] === "") {
      canAdd = false;
      errorText = "Please ensure Incident Name and Local Incident Identifier are both set.";
    }

    if ((this.state.attributes[originFields.discoveryAcres] === null || this.state.attributes[originFields.discoveryAcres] === "") & this.state.attributes[originFields.incidentTypeCategory] !== "FA") {
      canAdd = false;
      errorText = "Please provide a value for Discovery Acres.";
    }

    if (this.state.attributes[originFields.pooProtectingUnit] === null || this.state.attributes[originFields.pooProtectingUnit] === "") {
      canAdd = false;
      errorText = "Please provide a value for Protecting Unit.";
    }

    if (this.state.attributes[originFields.incidentTypeCategory] === null || this.state.attributes[originFields.incidentTypeKind] === null || this.state.attributes[originFields.incidentTypeCategory] === "" || this.state.attributes[originFields.incidentTypeKind] === "") {
      canAdd = false;
      errorText = "Please provide a value for Category.";
    }

    let validationInfo = getOriginValidationInfo(this.state.attributes, []);
    if (!validationInfo.isValid) {
      canAdd = false;
    }
    this.setState({
      canAddIncident: canAdd,
      errorText: errorText
    });
  }

  handleBlur = () => {

    if (this.state.attributes[originFields.name] !== null || this.state.attributes[originFields.localIncidentIdentifier] === null) {
      return;
    }
    else {
      let attributes = this.state.attributes;
      attributes[originFields.name] = attributes[originFields.localIncidentIdentifier];

      this.setState({
        attributes: attributes,
        incidentNameValue: attributes[originFields.localIncidentIdentifier]
      });
    }
  }

  getUnitIdAlert = () => {
    if (this.state.showUnitIdWarning) {
      return (<Alert severity={(this.state.unitIdIsValid) ? "success" : "warning"}>{this.state.unitIdString}</Alert>);
    }

    return (this.state.isQueryingUnitId) ? (<CircularProgress size={18} thickness={3} color={theme.palette.primary1Color} />) : "";
  }

  onUpdateProp = (name, value) => {
    let changedLatLong = false;
    let updatedLatValue = this.state.latValue;
    let updatedLongValue = this.state.longValue;

    if (name === originFields.name) {
      this.setState({
        incidentNameValue: value
      });
    }

    if (name === originFields.localIncidentIdentifier) {
      this.setState({
        localIncidentIdentifierValue: value
      });
    }

    if (name === "lat") {
      changedLatLong = true;
      updatedLatValue = value;
      this.setLatLongFromUserInput(updatedLatValue, updatedLongValue);
      this.setState({
        latValue: value
      });
    }

    if (name === "long") {
      if (!value.startsWith("-")) {
        value = "-" + value;
      }

      if (value.endsWith("E") && !value.startsWith("-")) {
        value = "-" + value;
      }

      changedLatLong = true;
      updatedLongValue = value;

      this.setLatLongFromUserInput(updatedLatValue, updatedLongValue);
      this.setState({
        longValue: value
      });
    }

    if (name === originFields.pooProtectingUnit) {
      this.setState({
        pooProtectingUnit: value
      });

      this.props.setNewIncidentProtectingUnit(value);
    }

    if (name === originFields.discoveryAcres) {
      this.setState({
        fireSize: value
      });
    }

    if (!changedLatLong) {
      let attributes = this.state.attributes;

      if (name === originFields.incidentTypeCategory) {
        attributes[originFields.incidentTypeKind] = (value === "FA") ? "FM" : "FI";

        if (value === "FA") {
          attributes[originFields.discoveryAcres] = 0;
          this.setState({
            fireSize: value
          });
        }
      }

      attributes[name] = value;

      this.setState({
        attributes: attributes
      });

      this.checkAttributes(this.state.latLongIsValid);
    }
    else {
      this.checkAttributes(this.state.latLongIsValid);
    }
  }

  render() {
    const validationInfo = getOriginValidationInfo(this.state.attributes, []);
    const unitIdAlert = this.getUnitIdAlert();
    return (

      <Dialog
        title="Add New Incident"
        modal={true}
        titleStyle={styles.errorDialogTitle}
        open={this.props.open}
        fullScreen
        autoScrollBodyContent={true}>
        <form autoComplete="off" noValidate>
          <div className="incident-attribute">
            <Typography variant="h6" gutterBottom>Fire Point of Origin</Typography>
            <Alert severity="warning">Avoid duplicate entries: If your unit has an IRWIN-connected CAD, please check with your dispatcher before creating a fire in Inspector.</Alert>
            <NewIncidentMap
              open={this.props.open}
              onCoordinateUpdate={this.updateCoords}
              manualLat={this.state.lat}
              manualLong={this.state.long}
            />
          </div>

          <Table>
            <TableBody>
              <TableRow className="incident-attribute">
                <TableCell className="incident-attribute-cell">
                  <Typography variant="h6" gutterBottom>Latitude</Typography>
                </TableCell>
                <TableCell>
                  <TextField
                    id="latitude"
                    className="newincident-latlong-textField"
                    value={this.state.latValue}
                    onChange={(event) => {
                      this.onUpdateProp("lat", event.target.value);
                    }}
                    margin="dense"
                    required
                    variant="outlined"
                  />
                </TableCell>
                <TableCell>
                  <Select
                    native
                    onChange={(event) => {
                      this.handleLLFormatChange(event.target.value);
                    }}
                    value={this.state.ddFormat} className="newincident-textField-zindex">
                    <option value="dd">Decimal Degrees</option>
                    <option value="ddm">Degrees Decimal Minutes</option>
                    <option value="dms">Degrees Minutes Seconds</option>
                  </Select>
                </TableCell>
              </TableRow>
              <TableRow className="incident-attribute">
                <TableCell className="incident-attribute-cell">
                  <Typography variant="h6" gutterBottom >Longitude</Typography>
                </TableCell>
                <TableCell>
                  <TextField
                    id="longitude"
                    className="newincident-latlong-textField"
                    value={this.state.longValue}
                    onChange={(event) => {
                      this.onUpdateProp("long", event.target.value);
                    }}
                    margin="dense"
                    required
                    variant="outlined"
                  />
                </TableCell>
                <TableCell>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <div className="incident-field">
            <div className="newincident-textField">
              <Typography variant="h6" gutterBottom >Local Incident Identifier</Typography>
              <TextField
                id={originFields.localIncidentIdentifier}
                ref={this.locaIndentifierRef}
                onBlur={this.handleBlur}
                value={this.state.localIncidentIdentifierValue}
                className="newincident-textField"
                onChange={(event) => {
                  this.onUpdateProp(originFields.localIncidentIdentifier, event.target.value);
                }}
                margin="dense"
                required
                variant="outlined"
                error={validationInfo.errors.hasOwnProperty(originFields.localIncidentIdentifier)}
                helperText={validationInfo.errors[originFields.localIncidentIdentifier]}
              />
              <Button onClick={this.lookupLocalId} disabled={!this.state.pooProtectingUnit} color="primary">Find Most Recent</Button>
            </div>
            <div className="newincident-textField">
              <Typography variant="h6" gutterBottom>Incident Name</Typography>
              <TextField
                id={originFields.name}
                ref={this.incidentNameRef}
                onFocus={this.handleBlur}
                className="newincident-textField"
                value={this.state.incidentNameValue}
                onChange={(event) => {
                  this.onUpdateProp(originFields.name, event.target.value);
                }}
                margin="dense"
                required
                variant="outlined"
                error={validationInfo.errors.hasOwnProperty(originFields.name)}
                helperText={validationInfo.errors[originFields.name]}
              />
            </div>
          </div>

          <div className="incident-field">
            <div className="newincident-textField">
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">Request FireCode?</FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  onChange={(event) => {
                    this.onUpdateProp(originFields.isFireCodeRequested, event.target.value);
                    this.props.setNewIncidentIsFireCodeRequest(event.target.value);
                    this.setState({
                      isFireCodeRequest: event.target.value,
                    });
                  }}
                  value={this.state.attributes[originFields.isFireCodeRequested]}>
                  <FormControlLabel value={1} control={<Radio />} label="Yes" />
                  <FormControlLabel value={0} control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>


            </div>
            <div className="newincident-textField">
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">Is FS Assisted?</FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  onChange={(event) => {
                    this.onUpdateProp(originFields.isFSAssisted, event.target.value);
                    this.props.setNewIncidentIsFSAssist(event.target.value)
                    this.setState({
                      isFSAssist: event.target.value,
                    });
                  }}
                  value={this.state.attributes[originFields.isFSAssisted]}>
                  <FormControlLabel value={1} control={<Radio />} label="Yes" />
                  <FormControlLabel value={0} control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl>
            </div>

          </div>

          <div className="incident-field">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div className="newincident-textField">
                <Typography variant="h6" gutterBottom>Fire Discovery Date</Typography>

                <KeyboardDatePicker
                  id="fireDiscoveryDate"
                  value={this.state.attributes["fireDiscoveryDate"]}
                  initialFocusedDate={this.props.defaultDate}
                  locale="en-US"
                  format="MM/dd/yyyy"
                  error={validationInfo.errors[originFields.discoveryDate]}
                  helperText={validationInfo.errors[originFields.discoveryDate]}
                  onChange={(event, date) => {
                    this.onUpdateProp("fireDiscoveryDate", event);
                  }} />

              </div>
              <div className="newincident-textField">
                <Typography variant="h6" gutterBottom>Fire Discovery Time</Typography>
                <TimePicker
                  id="fireDiscoveryTime"
                  className="time-picker"
                  ampm={false}
                  value={this.state.attributes["fireDiscoveryTime"]}
                  onChange={(event) => {
                    this.onUpdateProp("fireDiscoveryTime", event);
                  }}
                />
              </div>
            </MuiPickersUtilsProvider>
          </div>
          <div className="incident-field">

            <div className="newincident-textField">
              <Typography variant="h6" gutterBottom>Category</Typography>
              <Select
                native
                defaultValue="WF"
                onChange={(event) => {
                  this.onUpdateProp(originFields.incidentTypeCategory, event.target.value);
                }}
                id={originFields.incidentTypeCategory}>
                <option value="FA">False Alarm</option>
                <option value="RX">Prescribed Fire</option>
                <option value="WF">Wildfire</option>
                <option value="DF">Debris Fire</option>
                <option value="SF">Structure Fire</option>
                <option value="VF">Vehicle Fire</option>
                <option value="NS">Non-Statistical/Other</option>
              </Select>
            </div>

            <div className="newincident-textField">
              <Typography variant="h6" gutterBottom>Incident Size</Typography>
              <TextField
                id={originFields.discoveryAcres}
                className="newincident-textField"
                value={this.state.fireSize}
                type="number"
                disabled={this.state.attributes[originFields.incidentTypeCategory] === "FA"}
                onChange={(event) => {
                  this.onUpdateProp(originFields.discoveryAcres, event.target.value);
                }}
                margin="dense"
                required
                variant="outlined"
                error={validationInfo.errors[originFields.discoveryAcres]}
                helperText={(this.state.attributes[originFields.incidentTypeCategory] === "FA") ? "Disabled for False Alarm" : validationInfo.errors[originFields.discoveryAcres]}
              />
            </div>
          </div>

          <div className="incident-field">

            <div className="newincident-textField">
              <Typography variant="h6" gutterBottom>Protecting Unit</Typography>
              <TextField
                id={originFields.pooProtectingUnit}
                className="newincident-textField"
                value={this.state.pooProtectingUnit}
                inputProps={{ style: { textTransform: 'uppercase' } }}
                onChange={(event) => {
                  this.onUpdateProp(originFields.pooProtectingUnit, event.target.value);
                }}
                margin="dense"
                required
                variant="outlined"
                error={validationInfo.errors.hasOwnProperty(originFields.pooProtectingUnit)}
                helperText={validationInfo.errors[originFields.pooProtectingUnit]}
              />
              <Button onClick={this.verifyUnitId} color="primary">Validate</Button>
            </div>
            <div className="newincident-textField-bottom">
              {unitIdAlert}
            </div>

          </div>

        </form>
        <DialogActions>
          <Button onClick={this.props.onNewIncidentClose} color="primary">
            Cancel
          </Button>
          <Tooltip title={this.state.errorText}>
            <span>
              <Button onClick={this.onAddNewIncident} color="primary" disabled={!this.state.canAddIncident}>
                Add Incident
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
        <Snackbar
          open={this.state.showAddFailure}
          message={this.state.addFailureMessage}
          autoHideDuration={6000}
          onClose={this.handleSnackRequestClose}
        />
      </Dialog>
    )
  }
}


const mapStateToProps = state => ({
  incident: state.incident
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...incidentOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NewIncidentDialog);
